import { queryOptions } from '@tanstack/react-query'
import type { DashboardCard, DashboardClass, DashboardView } from './dashboard'
import { apiGet } from './client'

/**
 * Tabloul de bord al modulului Easeedesk - `GET /api/v2/easeedesk/dashboard`.
 *
 * Aceleasi carduri ca pe tabloul central, deci si acelasi tip de card
 * (`DashboardCard` din `api/dashboard.ts`); ce lipseste fata de el sunt
 * tablele proprii, sfatul agentului si wallboardul - tabloul de modul nu le
 * avea nici in portal.
 *
 * Fisier separat de `api/dashboard.ts`: acela e al benzii de tablouri, care
 * spune raspicat ca nu serveste tablouri de modul, iar Easeedesk se scrie in
 * banda lui.
 */
export interface EaseedeskDashboard {
  pageTitle: string
  lead: string
  boardUrl: string
  cards: DashboardCard[]
  tally: { read: number; unreadable: number }
  noCompany: boolean
  history: boolean
  board: { kind: string; key: string; view: string; override: number; edit: boolean }
  views: Record<string, DashboardView>
  classes: Record<string, DashboardClass>
  windows: Record<string, string>
  scope: { days: number; class: string; company: number; office: number }
}

/** Perspectiva, fereastra si clasa de active calatoresc in adresa, ca in portal. */
export function easeedeskDashboardQuery(search: string) {
  const q = search.startsWith('?') ? search : search ? `?${search}` : ''
  return queryOptions({
    queryKey: ['easeedesk', 'dashboard', q],
    queryFn: () => apiGet<EaseedeskDashboard>(`/easeedesk/dashboard${q}`),
  })
}
